<template>
  <div :loading="loading">
    <h5>Métodos de Pagamento</h5>
    <v-alert
      v-if="Object.keys(reducedPayments).length === 0"
      class="mb-0"
      color="warning"
      variant="tonal"
      text
    >
      Nenhum dado encontrado, verifique as filtros
    </v-alert>
    <div class="d-flex flex-column gap-3">
      <v-card
        v-for="(channel, id) in reducedPayments"
        :key="`channel-${id}`"
        class="rounded"
        outlined
        :loading="loading"
      >
        <div class="pa-3 pb-0">
          <b>{{ channel.name }}</b>
        </div>
        <v-simple-table dense>
          <thead>
            <tr>
              <th>Forma de Pagamento</th>
              <th class="text-center">Operações</th>
              <th class="text-center">Ingressos</th>
              <th class="text-end">Total Líquido</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="paymentType in channel.paymentType"
              :key="`item-${paymentType.name}`"
            >
              <td colspan="1">{{ paymentTypes[paymentType.name].text }}</td>
              <td colspan="1" class="text-center">
                {{ paymentType.quantity | number }}
              </td>
              <td colspan="1" class="text-center">
                {{ paymentType.ticketQuantity | number }}
              </td>
              <td colspan="1" class="text-end">
                {{ paymentType.amount | currency }}
              </td>
            </tr>
            <tr class="font-weight-bold text-15">
              <td colspan="1">Total</td>
              <td colspan="1" class="text-center">
                {{ channel.quantity | number }}
              </td>
              <td colspan="1" class="text-center">
                {{ channel.ticketQuantity | number }}
              </td>
              <td colspan="1" class="text-end">
                {{ channel.amount | currency }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import PAYMENT from "@/utils/payment";
export default {
  name: "ResumePaymentMethods",
  props: {
    party: {
      type: Object,
      required: true,
    },
    payments: {
      type: Array,
      required: true,
    },
    tickets: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      paymentTypes: PAYMENT.paymentType,
    };
  },
  computed: {
    reducedPayments() {
      return this.payments.reduce((acc, payment) => {
        const channel = payment.paymentMethod === "POS" ? "POS" : "ONLINE";

        if (!acc[channel]) {
          acc[channel] = {
            name: channel,
            quantity: 0,
            ticketQuantity: 0,
            amount: 0,
            paymentType: {},
          };
        }

        if (!acc[channel].paymentType[payment.paymentType]) {
          acc[channel].paymentType[payment.paymentType] = {
            name: payment.paymentType,
            quantity: 0,
            ticketQuantity: 0,
            amount: 0,
          };
        }

        payment.Ticket.forEach((ticket) => {
          // sum ticket group
          acc[channel].amount += ticket.amount - ticket.platformFee;
          acc[channel].ticketQuantity += 1;

          // sum ticket block
          acc[channel].paymentType[payment.paymentType].amount +=
            ticket.amount - ticket.platformFee;
          acc[channel].paymentType[payment.paymentType].ticketQuantity += 1;
        });

        acc[channel].quantity += 1;
        acc[channel].paymentType[payment.paymentType].quantity += 1;

        return acc;
      }, {});
    },
  },
};
</script>
